import React, { Component } from "react";
import axios from "axios";
import { Country, State, City } from 'country-state-city';


class ApplyProfileForm extends Component {
    state = {
        isActive: false,
        hasChanges: false,
        windowHeight: window.innerHeight - 60,
        firstname: '',
        lastname: '',
        middlename: '',
        phone: '',
        address: '',
        email: '',
        country: '',
        city: '',
        venue: '',
        specialisation: '',
        advertise: '',
        otherOption: '',
        selectedCountry: '',
        selectedState: '',
        cities: [],
        states: [],
        profile_image: null,
        selectedImage: null,
        originalData: null,
        error: '',

    };
    // fileInputRef = React.createRef();

    handleOutsideClick = (event) => {
        if (this.node && !this.node.contains(event.target)) {
            this.setState({ isActive: false, });
            const formdisplay = document.querySelector("div.dash_add_course_cover.applyform")
            formdisplay.style.display = "none"
        }

    };
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('mousedown', this.handleOutsideClick);
        this.fetchprofile()
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedCountry !== prevState.selectedCountry || this.state.selectedState !== prevState.selectedState) {
            if (this.state.selectedCountry) {
                const countryStates = State.getStatesOfCountry(this.state.selectedCountry);
                this.setState({ states: countryStates });

                if (!this.state.selectedState) {
                    this.setState({ cities: [] });
                    return;
                }

                const countryCities = City.getCitiesOfState(this.state.selectedCountry, this.state.selectedState);
                this.setState({ cities: countryCities });

            } else {
                this.setState({ states: [], cities: [] });
            }
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleResize = () => {
        this.setState({ windowHeight: window.innerHeight - 60 });
    };





    fetchprofile = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/student/profile/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            const profileData = response.data;
            this.setState({
                courses: profileData,
                firstname: profileData.first_name || "",
                lastname: profileData.last_name || "",
                middlename: profileData.middle_name || "",
                phone: profileData.phone_number || "",
                address: profileData.address || "",
                email: profileData.email || "",
                selectedCountry: profileData.country || "",
                selectedState: profileData.city || "",
                venue: profileData.venue || "",
                specialisation: profileData.interested_course || "",
                // nation: profileData.nation || "",
                // gender: profileData.gender || "",
                // DOB: profileData.DOB || "",
                // affiliation: profileData.affiliation || "",
                advertise: profileData.source || "",  // Assuming 'source' maps to 'advertise'
                profile_image: profileData.profile_picture ? `https://api.geoinfoacademy.com${profileData.profile_picture}` : null, // Handle image URL
                selectedImage: profileData.profile_picture ? `https://api.geoinfoacademy.com${profileData.profile_picture}` : null, // Handle image URL
                originalData: profileData, // Store the original data
                hasChanges: false, // Initially, no changes

            });
            console.log("API Response studnet, to see if i am realy getting the full information from this applied profile:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
    };




    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, hasChanges: true })
        console.log("API Response student information:", this.state)
    }

    handleSubmit = async (event) => {
        event.preventDefault();

        let hasLocalChanges = false;
        if (
            this.state.firstname !== this.state.originalData.first_name ||
            this.state.lastname !== this.state.originalData.last_name ||
            this.state.middlename !== this.state.originalData.middle_name ||
            this.state.phone !== this.state.originalData.phone_number ||
            this.state.address !== this.state.originalData.address ||
            this.state.email !== this.state.originalData.email ||
            this.state.selectedCountry !== this.state.originalData.country ||
            this.state.selectedState !== this.state.originalData.city ||
            this.state.venue !== this.state.originalData.venue ||
            this.state.specialisation !== this.state.originalData.interested_course ||
            // this.state.gender !== this.state.originalData.gender ||
            // this.state.affiliation !== this.state.originalData.affiliation ||
            this.state.advertise !== this.state.originalData.source ||
            // this.state.otherOption !== (this.state.originalData.source === 'Others' ? this.state.originalData.source : '') ||
            (this.state.profile_image instanceof File) || // Check for new file
            (this.state.hasChanges && !this.state.profile_image && this.state.originalData && this.state.originalData.profile_picture === null) // Check for image deletion
        ) {
            hasLocalChanges = true;
        }

        if (!hasLocalChanges) {
            console.log("No changes to profile. Skipping update.");
            this.setState({ error: "No changes to profile" });
            setTimeout(() => {
                this.setState({ error: '' });
            }, 5000);
            return;
        }

        const formData = new FormData();
        formData.append('first_name', this.state.firstname);
        formData.append('last_name', this.state.lastname);
        formData.append('middle_name', this.state.middlename);
        formData.append('phone_number', this.state.phone);
        formData.append('address', this.state.address);
        // formData.append('gender', this.state.gender);
        formData.append('email', this.state.email);
        formData.append('country', this.state.selectedCountry);
        formData.append('city', this.state.selectedState);
        formData.append('venue', this.state.venue);
        formData.append('interested_course', this.state.specialisation);
        // formData.append('affiliation', this.state.affiliation);

        if (this.state.advertise === "Others") {
            formData.append('source', this.state.otherOption);
        } else {
            formData.append('source', this.state.advertise);
        }

        if (this.state.profile_image instanceof File) {
            formData.append('profile_picture', this.state.profile_image);
            console.log("check image", this.state.profile_image);
        } else if (this.state.hasChanges && !this.state.profile_image && this.state.originalData && this.state.originalData.profile_picture) {
            formData.append('profile_picture', null);
            console.log("Deleting Image");
        } else {
            console.log("No new image selected, using existing or no image.");
        }

        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await axios.patch('https://api.geoinfoacademy.com/api/student/profile/', formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            console.log('API response:', response);
            this.setState({
                hasChanges: false,
                originalData: { ...this.state.originalData, ...this.state }, // Update original data
                error: 'Changes Updated'
            });

            setTimeout(() => {
                this.setState({ error: '' });
            }, 5000);
            this.fetchprofile();


            const {course_id } = this.props
            try {
                const response = await axios.post(
                    `https://api.geoinfoacademy.com/api/interested-courses/`,
                    {
                        course_id: course_id, // Place course_id in the request body
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                console.log(response.data.message)
                window.location.href = `/description/${course_id}/paymentverify`;
            }
            catch (error) {
                console.error("Error initiating payment:", error);
            }


        } catch (error) {
            console.error('Error submitting form:', error);
            this.setState({ error: "Error Occured" });
            setTimeout(() => {
                this.setState({ error: '' });
            }, 5000);
        }
    };




    handleCountryChange = (event) => { // Arrow function for automatic binding
        this.setState({ selectedCountry: event.target.value, selectedState: '' });
    };

    handleStateChange = (event) => { // Arrow function for automatic binding
        this.setState({ selectedState: event.target.value });
    };




    render() {
        const { onResize } = this.props;
        const countries = Country.getAllCountries();
        return (
            <div className="dash_add_course_cover applyform" style={{ width: `calc(100% - ${onResize}px - 3px)`, height: this.state.windowHeight }}>
                <div className="dash_form_container" ref={(node) => (this.node = node)}>
                    <h2>Apply for Course</h2>
                    <form onSubmit={this.handleSubmit}>
                        <div className="cover">
                            <div className="input">
                                <label>First Name</label><br />
                                <input type="text" placeholder="First Name" name="firstname" id="firstname" value={this.state.firstname} onChange={this.handleInputChange} className="apply" required />
                            </div>
                            <div className="input">
                                <label>Last Name</label>
                                <input type="text" placeholder="Last Name" name="lastname" id="lastname" value={this.state.lastname} onChange={this.handleInputChange} required/>
                            </div>
                        </div>
                        <label>Middle Name</label><br />
                        <input type="text" placeholder="Middle Name" name="middlename" id="middlename" value={this.state.middlename} onChange={this.handleInputChange} className="apply" required/><br />
                        <label>Email</label><br />
                        <input type="email" placeholder="@gmail.com" autoComplete="email" name="email" id="email" value={this.state.email} onChange={this.handleInputChange} className="apply" required /><br />
                        <label>Phone</label><br />
                        <input type="number" placeholder="0900000000" autoComplete="phone" min="0" name="phone" id="phone" value={this.state.phone} onChange={this.handleInputChange} className="apply" required /><br />
                        <label>Address</label><br />
                        <input type="text" placeholder="No 9 unknown street" name="address" id="address" value={this.state.address} onChange={this.handleInputChange} className="apply" required /><br />

                        <label>Country</label><br />
                        <select value={this.state.selectedCountry} onChange={this.handleCountryChange} id="country" className="apply" required>
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                                <option key={country.isoCode} value={country.isoCode}>
                                    {country.name}
                                </option>
                            ))}
                        </select><br />
                        <label htmlFor="city">City</label><br />
                        <select value={this.state.selectedState} onChange={this.handleStateChange} id="city" className="apply" required>
                            <option value="">Select State</option>
                            {this.state.states.map((state) => (
                                <option key={state.isoCode} value={state.isoCode}>
                                    {state.name}
                                </option>
                            ))}
                        </select><br />
                        <label htmlFor="venue">Select your preferred training venue</label><br />
                        <select name="venue" id='venue' value={this.state.venue} onChange={this.handleInputChange} className="apply" required>
                            <option value="">Select training venue</option>
                            <option value="Online">Online</option>
                            <option value="Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos">Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos</option>
                            <option value="6th floor, Nigeria Reinsurance Corporation building, Plot 784A Herbert Macaulay Way, North, Abuja.">6th floor, Nigeria Reinsurance Corporation building, Plot 784A Herbert Macaulay Way, North, Abuja.</option>

                        </select><br />
                        <label htmlFor="advertise">How did you get this information</label><br />
                        <select name="advertise" id='advertise' value={this.state.advertise} onChange={this.handleInputChange} className="apply" required>
                            <option value="">Select</option>
                            <option value="Friends">Friends</option>
                            <option value="Families">Families</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="T.V/Radio">T.V/Radio</option>
                            <option value="School">School</option>
                            <option value="Social Media">Social Media</option>
                            <option value="Google">Google</option>
                            <option value="Others">Others</option>
                        </select>
                        <label>Area of specialisation </label><br />
                        <input type="text" name="specialisation" id="specialisation" placeholder="e.g. Surveying, Geology, Agriculture" className="apply" value={this.state.specialisation} onChange={this.handleInputChange} required/><br /><br />

                        <button >Proceed</button>
                    </form>
                </div>
            </div>
        )
    }
}


export default ApplyProfileForm